import { render } from "./Dialog.vue?vue&type=template&id=e314eb0c&scoped=true"
const script = {}

import "./Dialog.vue?vue&type=style&index=0&id=e314eb0c&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e314eb0c"]])

export default __exports__